import { isValidEmail } from '@/utils/libranzasFormat';
import './libranzasContactForm.scss';

interface LibranzasContactFormProps {
    email: string;
    onEmailChange: (value: string) => void;
    celular: string;
    onCelularChange: (value: string) => void;
}

const LibranzasContactForm = ({ email, onEmailChange, celular, onCelularChange }: LibranzasContactFormProps) => (
    <div className="m-libranzas-contact-form">
        <div className="m-libranzas-contact-form__heading">
            <h2 className="m-libranzas-contact-form__heading__title">Datos de contacto</h2>
            <p className="m-libranzas-contact-form__heading__subtitle">
                Confirma o actualiza tu correo y celular para recibir notificaciones del pago.
            </p>
        </div>
        <table className="m-libranzas-contact-form__table">
            <tbody>
                <tr>
                    <th>Correo electrónico</th>
                    <th>Celular</th>
                </tr>
                <tr>
                    <td>
                        <div className={`f-a-input__box${!isValidEmail(email) && email.length > 0 ? ' __error' : ''}`}>
                            <input
                                id="email-libranzas"
                                data-testid="email-libranzas"
                                type="email"
                                value={email}
                                aria-label="Correo electrónico"
                                onChange={(e) => onEmailChange(e.target.value)}
                            />
                        </div>
                        {!isValidEmail(email) && email.length > 0 && (
                            <span className="f-a-input__error">Ingresa un correo electrónico válido</span>
                        )}
                    </td>
                    <td>
                        <div className={`f-a-input__box${celular.length > 0 && celular.length !== 10 ? ' __error' : ''}`}>
                            <input
                                id="celular-libranzas"
                                data-testid="celular-libranzas"
                                type="tel"
                                value={celular}
                                maxLength={10}
                                aria-label="Celular"
                                onChange={(e) => onCelularChange(e.target.value.replace(/\D/g, ''))}
                            />
                        </div>
                        {celular.length > 0 && celular.length !== 10 && (
                            <span className="f-a-input__error">El celular debe tener 10 dígitos</span>
                        )}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
);

export default LibranzasContactForm;
